import { getColorFromMoral, getMalusFromMoral } from "enefel/moral";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import CustomTooltip from "../Interface/Tooltip";

type MoraleDescriptionProps = {
  morale: number;
};

const MoraleDescription: React.FC<MoraleDescriptionProps> = React.memo(
  ({ morale }) => {
    const { t } = useTranslation();
    const malus = getMalusFromMoral(morale);
    return (
      <div>
        <div>
          {t("t:Moral", "__Moral")}: {morale}%
        </div>
        {malus > 0 && (
          <div>
            {t("t:Time malus Detail", "__Time malus Detail")}: +{malus}%
          </div>
        )}
      </div>
    );
  }
);
const MoraleWrapper = styled.div`
  background-color: black;
  height: 3px;
  width: 100%;
  border-radius: 5px;
`;
const Morale = styled.div`
  width: ${(props) => `${props.morale}%`};
  background-color: ${(props) => getColorFromMoral(props.morale)};
  height: 2px;
  border-radius: 5px;
`;

type PlayerMoraleProps = {
  player: any;
};

const PlayerMorale: React.FC<PlayerMoraleProps> = React.memo(({ player }) => {
  return (
    <CustomTooltip
      placement="top"
      title={<MoraleDescription morale={player.moral} />}
    >
      <MoraleWrapper>
        <Morale morale={player.moral}></Morale>
      </MoraleWrapper>
    </CustomTooltip>
  );
});

export default PlayerMorale;
